module.exports = __webpack_public_path__ + "static/media/full-down-arrow.faf0f88e.svg";